import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ScreenTitleService {
  private title: string;
  constructor() { }

  public setScreenTitle = new BehaviorSubject<string>(this.title);
  castTitle = this.setScreenTitle.asObservable();

  setTitle(value: string) {
    this.title = value;
    this.setScreenTitle.next(this.title);
  }
}
